import { AppConfigContext } from "@/contexts/AppConfigProvider";
import { useContext } from "react";
import type { AppConfig } from "@/types/AppConfig";

export function useAppConfig(): AppConfig {
  const context = useContext(AppConfigContext);

  if (!context) {
    throw new Error("useAppConfig must be used within an AppConfigProvider");
  }

  return context;
}
